import React from 'react';

const BackToHome = () => {
    return (
        <div className="button">
            <a title="首页" className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href={ process.env.PUBLIC_URL + "/" }>回到首页</a>
        </div>
    );
};

export default BackToHome;
